/**
 * Renders the unavailable lots panel
 * @returns {string} HTML string for panel content.
 */
import { unavailableLotsIconSvg } from 'constants/svg-assets';

export default function renderUnavailableLotsPanel() {
	return `
		<div class="nhs-c-native-interactive-site-map__unavailable-lots" data-qa="native_ism_unavailable_lots_panel">
			<div class="nhs-c-native-interactive-site-map__unavailable-lots-content">
				${unavailableLotsIconSvg}
				<h4 class="nhs-o-typography--sans-body-1-small-book">No homes available</h4>
				<p class="nhs-o-typography--sans-label-1-extra-extra-small-regular">Check out other lots</p>
			</div>
		</div>
	`;
}
